<div [ngClass]="'main-container-'+popupStyle">
    <div *ngIf="!isFullScreenPopUp" class="page-title">{{title}}</div>
    <div class="row">
        <div [ngClass] = "[(panelWidth > marignWidth) ? 'col-6 upload-container-main': 'col-6 col-md-12 upload-container-short']" >
            <!-- if and only if the media is of type image, cropping will be shown -->
            <app-image-crop-component  
                [cropFrameMode]="cropFrameMode" 
                [imageUrl]="imageUrl"
                [isFullScreenPopUp] = "isFullScreenPopUp"      
                [cropInfo]="model?.cropInfo"
                [dropZoneInfo]="dropZoneInfo"
                [popupWidth]="popupWidth"
                (fileCropInfo)="fileCropInfoUpdate($event)"
                (isfileCleared)="removeBtnClick()"
                *ngIf="isFileAdded && showCropPannel"></app-image-crop-component>

            <!-- else default preview is shown in the upload component itself as it is now-->

            <!-- Drag and drop zone -->
            <div *ngIf="!isFileAdded" [ngClass]="'dropzone-'+popupStyle" appDrag (files)="filesDropped($event)" id="dropZone" [ngClass]="{'dropzone-error': !isAcceptedFiles}" >
                <div *ngIf="!isFileAdded">
                    <!-- <img class="dropzone-image" src= model.mediaUrl> -->
                    <img [ngClass]="'dropzone-image-'+popupStyle" src="assets/multimedia-module/Drag.png">
                    <div [ngClass]="'dropzone-text-'+popupStyle">
                        <div>{{"ph_drag_and_drop" | translate}}</div>
                        <div class="text-description">{{ "ph_drag_and_drop_all_type" | translate }}</div>
                    </div>
                </div>
                
            <!-- Browse and upload -->
            <div *ngIf="!isFileAdded" [ngClass]="'browse-button-'+popupStyle">
                    <button class ="btn btn-cancel" [ngClass]="'input-btn-'+popupStyle"  (click)="chooseBtnClick()">{{ "lbl_browse_for_file" | translate}}</button>
                    <input #file type="file" accept=".jpg, .jpeg, .bmp, .tif, .png, .wav, .mp3, .mp4, .avi, .mpg, .doc, .docx, .rtf, .txt, .pdf" class="input-btn"
                        (change)="preview(file.files[0]);" id="chooseFile" style="display:none"/>
            </div>
            </div>
            <!-- Image preview -->
            <div *ngIf="isFileAdded && !showCropPannel" [ngClass]="['dropzone-'+popupStyle, 'single-card-'+popupStyle]">
                <span *ngIf="isFileAdded" [ngClass]="'btn-remove-'+popupStyle" (click)="removeBtnClick()">
                    <img  class="close-icon" src="assets/multimedia-module/close-icon.png">    
                </span>
                <img [src]="nonImagePreview" [ngClass]="'preview-'+popupStyle" *ngIf = "!showCropPannel">
            </div>
            <div *ngIf="!isAcceptedFiles" [ngClass]="'file-error-'+popupStyle">{{fileErrorMessage | translate}}</div>

        </div>

        <div [ngClass] = "[(panelWidth > marignWidth) ? 'col-6 input-container-main': 'col-6 col-md-12 input-container-short']" >
            <form novalidate #f="ngForm" [ngClass]="['form-group-'+popupStyle, 'form-group-width-'+popupStyle]">
                <fieldset>
                    <div [ngClass]="'form-group-'+popupStyle">
                        <label>{{"lbl_picture_caption" | translate}}</label>
                        <input type="text" class="form-control" name="caption" [disabled] = "!isFileAdded"
                       [(ngModel)]="model.caption"
                            maxlength="80" #caption="ngModel" >                   
                    </div>

                    <div>
                            <div [ngClass]="'float-left tag form-group-'+popupStyle">
                                <label>{{"lbl_tag" | translate}}</label>
                                <input type="text" class="form-control" name="tag"  [disabled] = "!isFileAdded" [(ngModel)]="model.tag"
                                    maxlength="80" #tag="ngModel" >                
                            </div>

                <div [ngClass]="'float-left date form-group-'+popupStyle">
                    <label>{{"lbl_date" | translate}}</label>
                    <app-date-input-componnent [fieldEnabled]="isFileAdded" [ftDateObject]="model.date" (formattedDateModel)="dateValueSelected($event)" [tooltipPosition]="tooltipPosition" [popupWidth]="popupWidth"  [dateTooltipPlace]="dateTooltipPlace"></app-date-input-componnent>
                </div>

                        <div [ngClass]="'float-left place form-group-'+popupStyle" (click)="showNotImplemented()">
                            <label>{{"lbl_place" | translate}}</label>
                            <input type="text" class="form-control" name="place" [(ngModel)]="model.place"
                                maxlength="80" #place="ngModel" disabled>              
                        </div>
                </div>
                <div [ngClass]="[(isInvalidDate) ? 'show-error-description': '', 'description-'+popupStyle, 'form-group-'+popupStyle]">
                    <label>{{"lbl_description" | translate}}</label>
                    <textarea class="form-control"  name="description"  [disabled] = "!isFileAdded" [(ngModel)]="model.description"
                    maxlength="150" #description="ngModel"></textarea>
                </div>
            </fieldset>
            </form>
        </div>
        <div class = "footer">
            <div [ngClass]="'buttons-'+popupStyle">
                    <span>
                        <button type="button" [disabled] = "!isFileAdded" class="btn btn-primary btn-foot element-over-hand" 
                        [ngClass]="(isFileAdded)?'btn-active' : 'btn-disable'" (click)="upload()">
                            {{"lbl_save" | translate}}
                        </button>
                    </span>
                    <span><button type="button" class="btn btn-primary btn-foot btn-cancel element-over-hand"  (click)="cancel()"
                                    >{{"lbl_cancel" | translate }}</button></span>
            </div>
    </div>
    </div>

</div>